"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateGolfTotalSellValue = void 0;
const calculateGolfTotalSellValue = (golf_line) => {
    let val = 0;
    // Green Fee
    val =
        (golf_line?.green_fee?.cost + golf_line?.green_fee?.margin) *
            golf_line?.where_when_who?.number_of_golfers +
            Number(golf_line?.where_when_who.number_of_golfers % 2
                ? golf_line?.green_fee?.surcharge || 0
                : 0);
    // Caddies
    if (golf_line?.caddies?.enabled &&
        golf_line?.caddies?.payment_option !== null &&
        golf_line?.caddies?.payment_option !== "ON_ARRIVAL" &&
        golf_line?.caddies?.total) {
        val += golf_line?.caddies?.total;
    }
    // Carts
    if (golf_line?.carts?.enabled &&
        golf_line?.carts?.payment_option !== null &&
        golf_line?.carts?.payment_option !== "ON_ARRIVAL" &&
        golf_line?.carts?.types &&
        golf_line?.carts?.types?.length > 0) {
        golf_line?.carts?.types?.map(
        // eslint-disable-next-line array-callback-return
        (cart_type, idx) => {
            if (golf_line?.carts?.types)
                val += golf_line?.carts?.types[idx]?.total;
        });
    }
    return val;
};
exports.calculateGolfTotalSellValue = calculateGolfTotalSellValue;
